import {useSiteContext} from './useSiteContext';

export function useGeoFenceCode() {
  const {setState} = useSiteContext();

  function setGeoFenceCode(value: any) {
    setState((prevState: any) => {
      return {
        ...prevState,
        geoFenceCode: value,
      };
    });
  }
  return setGeoFenceCode;
}
